import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import FragmentFullContent from "../FragmentFullContent";
import CheckLoading from "../CheckLoading";
import { LoadStateInfo } from "../../../redux/common";
import PrizaGridBar from "./PrizaGridBar";
import BadgedAvatar from "../BadgedAvatar";

export interface PrizaAvatarGridItem {
    image?: string;
    title?: string;
    subtitle?: string;
    extra?: React.ReactNode;
    click?: () => void;
}

export interface Buttons {
    label: React.ReactNode;
    click: () => void;
}

export interface PrizaAvatarGridProps {
    list?: PrizaAvatarGridItem[];
    state: LoadStateInfo;
    retry?: () => void;
    toolbar: {
        label: React.ReactNode;
        buttons?: Buttons[];
        position?: "top" | "bottom" | undefined;
    }
    messages: {
        empty: string;
        error: string;
    }
    notStarted?: React.ReactNode;
    size?: string;
    alternativeContent?: React.ReactNode;
    buildContent?: () => React.ReactNode;
}

const PrizaAvatarGrid = (props: PrizaAvatarGridProps) => {
    const { list, state, retry, toolbar, messages, notStarted, size, alternativeContent } = props;
    const content = () => {
        if(!list || list.length == 0) {
            return (
                <FragmentFullContent>
                    <Typography variant="h6" component="div">
                        {messages.empty}
                    </Typography>
                </FragmentFullContent>
            );
        }
        return list.map(function (item, i) {
            const onClick = () => { 
                if (item.click) {
                    item.click();
                } else {
                    console.log("No click action defined for item", item);
                }
            };
            return <Paper sx={{ m: 1, p: 2 }} elevation={10} key={i}>
                <div key={i} onClick={onClick}>
                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                        <BadgedAvatar key={i}
                            title={`${item.title}`} 
                            avatar={`${item.image}`} 
                            size={size ? size : "80px"}
                        />
                        <Box sx={{ width: "100%" }}>
                            <Stack direction="column" justifyContent="space-between" alignItems="left">
                                <Typography variant="h5" component="span" 
                                    sx={{ width: "250px", overflow: "hidden", textOverflow: "ellipsis", 
                                    display: "block", textWrap: "nowrap", textAlign: "left" }}>
                                    {item.title}
                                </Typography>
                                <Typography variant="caption" component="span" 
                                    sx={{ width: "200px", overflow: "hidden", textOverflow: "ellipsis", 
                                        display: "block", textWrap: "nowrap", textAlign: "left" }}>
                                    {item.subtitle}
                                </Typography>
                                {item.extra ? item.extra : undefined}
                            </Stack>
                        </Box>
                    </Stack>
                </div>
            </Paper>
            ;
        });
    };

    const buildContent = () => {
        if(props.buildContent) {
            return props.buildContent();
        }
        if(alternativeContent) {
            return alternativeContent;
        }
        return <Grid container sx={{ /* backgroundColor: "#CCC" */ }} justifyContent="center" alignContent="center" textAlign="center">
            {content()}
        </Grid>;
    };

    const elToolbar = <PrizaGridBar toolbar={toolbar} retry={retry} />;
    return <Paper sx={{ width: "100%", minWidth: "300px" }} elevation={3}>
        {toolbar.position != "bottom" ? elToolbar : undefined}
        <Box display={"flex"} width="100%">
            <CheckLoading
                states={[state]}
                error={messages.error}
                content={buildContent}
                notStarted={notStarted}
                retry={retry} />
        </Box>
        {toolbar.position == "bottom" ? elToolbar : undefined}
    </Paper>;
};

export default PrizaAvatarGrid;